// mobile-menu.js — menú móvil estilo Nike con navegación drill-down. Autónomo.
(function () {
  'use strict';
  var dataEl = document.querySelector('[data-mmenu-data]');
  var drawer = document.getElementById('mmenu');
  if (!dataEl || !drawer) return;

  var MENU;
  try { MENU = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }

  var slider = drawer.querySelector('.mmenu__slider');
  var stack = [];

  function buildList(items, isRoot) {
    var wrap = document.createElement('div');
    wrap.className = 'mmenu__list';
    items.forEach(function (it) {
      var hasKids = it.children && it.children.length;
      var el = document.createElement(hasKids ? 'button' : 'a');
      el.className = 'mmenu__row' + (it.hot ? ' mmenu__row--hot' : '') + (!isRoot && !hasKids ? ' mmenu__row--leaf' : '');
      if (hasKids) el.type = 'button'; else el.href = it.url || '#';
      var html = '';
      if (it.icon) html += '<span class="mmenu__icon">' + it.icon + '</span>';
      html += '<span class="mmenu__txt">' + it.t + '</span>';
      if (hasKids) html += '<span class="mmenu__chev">›</span>';
      el.innerHTML = html;
      if (hasKids) el.addEventListener('click', function () { push(it.t, it.children, it.url); });
      wrap.appendChild(el);
    });
    return wrap;
  }

  function panel(title, items, isRoot, parentUrl) {
    var p = document.createElement('div');
    p.className = 'mmenu__panel';
    var head = document.createElement('div');
    head.className = 'mmenu__head';
    if (!isRoot) {
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'mmenu__hback';
      back.innerHTML = '‹ Volver';
      back.addEventListener('click', pop);
      head.appendChild(back);
    }
    var titleEl = document.createElement('span');
    titleEl.className = 'mmenu__htitle';
    titleEl.textContent = isRoot ? 'Menú' : title;
    head.appendChild(titleEl);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'mmenu__hclose';
    close.setAttribute('aria-label', 'Cerrar');
    close.innerHTML = '✕';
    close.addEventListener('click', closeDrawer);
    head.appendChild(close);
    p.appendChild(head);

    p.appendChild(buildList(items, isRoot));

    if (!isRoot && parentUrl) {
      var all = document.createElement('a');
      all.className = 'mmenu__seeall';
      all.href = parentUrl;
      all.textContent = 'Ver todo ' + title + ' →';
      p.appendChild(all);
    }

    if (isRoot) {
      var foot = document.createElement('div');
      foot.className = 'mmenu__foot';
      foot.innerHTML =
        '<a href="/account"><span class="mmenu__icon">👤</span> Mi cuenta</a>' +
        '<a href="https://api.whatsapp.com/send?phone=573173631566" target="_blank" rel="noopener"><span class="mmenu__icon">💬</span> Ayuda por WhatsApp</a>';
      p.appendChild(foot);
    }
    return p;
  }

  function push(title, items, parentUrl) {
    var p = panel(title, items, false, parentUrl);
    slider.appendChild(p);
    void p.offsetWidth; // forzar reflow para fijar el estado inicial (translateX 100%) antes de animar
    var prev = stack.slice(); // paneles existentes (sin el nuevo)
    stack.push(p);
    requestAnimationFrame(function () {
      prev.forEach(function (x) { x.classList.remove('is-active'); x.classList.add('is-left'); });
      p.classList.remove('is-left');
      p.classList.add('is-active');
    });
  }
  function pop() {
    if (stack.length <= 1) return;
    var top = stack.pop();
    top.classList.remove('is-active');
    top.classList.add('is-right');
    setTimeout(function () { if (top.parentNode) top.parentNode.removeChild(top); }, 320);
    var prev = stack[stack.length - 1];
    prev.classList.remove('is-left');
    prev.classList.add('is-active');
  }
  function openDrawer() {
    slider.innerHTML = '';
    stack = [];
    var root = panel('Menú', MENU, true);
    // El panel raíz aparece directo en su posición (sin transición): la animación
    // de entrada la da el propio cajón al deslizarse. Marcar is-active ANTES de
    // insertarlo evita que la transición translateX se congele a mitad de camino.
    root.classList.add('is-active');
    slider.appendChild(root);
    stack.push(root);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  // Cerrar al tocar el fondo
  var backdrop = drawer.querySelector('.mmenu__backdrop');
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Enganchar el botón "Menú" del header (solo en móvil; en escritorio abre el panel de categorías del tema)
  var btn = document.querySelector('.header__filters--all-categories');
  if (btn) {
    btn.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width:860px)').matches) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      }
    }, true);
  }
})();
